import axios from 'axios';

const api = axios.create({
  //baseURL: 'http://localhost:3000/', 
  baseURL: 'https://ehs-backend-pink.vercel.app/',
});

export default api;
